"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  justify-content: ", ";\n  padding: 0.5rem 0;\n  margin: 0 0 1.5rem;\n  font-size: 0.875rem;\n  color: ", ";\n  background: white;\n"])), function (p) {
  return p.alignItems || "center";
}, function (p) {
  return p.justifyContent || "center";
}, function (p) {
  return p.theme.colorLabel;
});

var PageHeader = function PageHeader(_ref) {
  var children = _ref.children,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    alignItems: alignItems,
    justifyContent: justifyContent,
    children: children ? children : /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {})
  });
};

var _default = PageHeader;
exports.default = _default;